export const AUTH_TOKEN_STORAGE = "tokenResponse";
export const AUTH_SESSION_STARTED_AT = "sessionStartedAt";
export const AUTH_USER_DETAILS = "userDetails";
export const AUTH_UNIT_PREFERENCES = "userUnitPreferences";
export const AUTH_GRAPH_PREFERENCES = "userGraphPreferences";
export const AUTH_INTERCOM_DETAILS = "intercomDetails";
export const AUTH_STORED_ROUTE = "storedRoute";
export const AUTH_PORTAL_PREFERENCES = "portalPreferences";
export const AUTH_HOSPITAL_CONFIGURATION = "hospitalConfiguration";
export const IS_MOBILE_APP = "isMobileApp";
export const SELECTED_WARDS = "selectedWards";
export const PATIENT_LIST_VARIANT = "patientListVariant";
export const PATIENT_IDS = "patientIds";
export const VIEWED_FIRST_PATIENT = "viewedFirstPatient";
export const NOTIFICATION = "notification";
export const AUTH_STAFF_PREFERENCES = "staffPreferences";
export const AUTH_WARD_CONFIGURATION = "wardConfiguration";
export const AUTH_TENANT_DETAILS = "tenantDetails";
export const AUTH_API_BASE_URL = "apiBaseUrl";
export const PATIENT_LIST_SCROLL_POSITION = "patientListScrollPosition";
export const PATIENT_LIST_LAST_SELECTED_ID = "patientListLastSelectedId";
export const PATIENT_LIST_LAST_SELECTED_PAGE = "patientListLastSelectedPage";
export const PATIENT_LIST_SORTING_STATE = "patientListSortingState";
export const CARE_INFO_SORTING_STATE = "careInfoSortingState";
export const ADMIN_SIDEBAR_COLLAPSED = "adminSidebarCollapsed";
